import { Form, FormSection } from "components/ResumeForm/Form";
import { Input } from "components/ResumeForm/Form/InputGroup";
import RichEditor from "./Form/QuillEditor";
import type { CreateHandleChangeArgsWithDescriptions } from "components/ResumeForm/types";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import { selectProjects, changeProjects } from "lib/redux/resumeSlice";
import type { ResumeProject } from "lib/redux/types";
import { AiSuggestion, AiSuggestionCTA } from "./Form/AiSuggestion";
import RichEditorWithSuggestions from "./Form/RichEditorWithSuggestions";

export const ProjectsForm = () => {
  const projects = useAppSelector(selectProjects);
  const dispatch = useAppDispatch();
  const showDelete = projects.length > 1;

  return (
    <Form form="projects" addButtonText="Add Project">
      {projects.map((item, idx) => {
        const { project, startDate, endDate, descriptions, projectLink } = item;
          
          const handleProjectChange = (
            ...[
              field,
              value,
            ]: CreateHandleChangeArgsWithDescriptions<ResumeProject>
          ) => {
            dispatch(changeProjects({ idx, field, value } as any));
          };
          const showMoveUp = idx !== 0;
          const showMoveDown = idx !== projects.length - 1;

          return (
            <FormSection
              key={item.id ?? idx}
              form="projects"
              idx={idx}
              showMoveUp={showMoveUp}
              showMoveDown={showMoveDown}
              showDelete={showDelete}
              deleteButtonTooltipText={"Delete project"}
            >
              <Input
                name="project"
                label="Project Name"
                placeholder="Awesome App"
                value={project}
                onChange={handleProjectChange}
                labelClassName="col-span-full"
              />
              <Input
                name="startDate"
                label="Start Date"
                placeholder="Fall 2024"
                value={startDate}
                onChange={handleProjectChange}
                labelClassName="col-span-3"
              />
              <Input
                name="endDate"
                label="End Date"
                placeholder="Fall 2024"
                value={endDate}
                onChange={handleProjectChange}
                labelClassName="col-span-3"
              />
              <Input
                name="projectLink"
                label="Project Link"
                placeholder="https://yourproject.com"
                value={projectLink}
                onChange={handleProjectChange}
                labelClassName="col-span-full"
              />
              {/* <RichEditor
                name="descriptions"
                value={descriptions}
                onChange={handleProjectChange}
                labelClassName="col-span-full"
                placeholder="Project Description"
              />
              <div className="col-span-full mt-2">
                <AiSuggestion />
                <AiSuggestionCTA />
              </div> */}
              <RichEditorWithSuggestions
                name="descriptions"
                value={descriptions}
                onChange={handleProjectChange}
                placeholder="Project Description"
                section="projects"
              />
            </FormSection>
          );
        }
      )}
    </Form>
  );
};
